var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{staticClass:"mt-0",attrs:{"loading":_vm.loading,"hide-details":""},on:{"click":function($event){$event.stopPropagation();return _vm.toggleSubmissionFlag(_vm.seminar)}},model:{value:(_vm.seminar.report),callback:function ($$v) {_vm.$set(_vm.seminar, "report", $$v)},expression:"seminar.report"}})
}
var staticRenderFns = []

export { render, staticRenderFns }